import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { routes } from '../../../redux/api/routes';
let { localStorageVar } = routes;

class OppsNoAccount extends Component {

	constructor(props){
        super(props);
        this.state = {
            localStorageVar : 'gessouserdetailscnet',
        }
    }

	componentWillMount() {
		var localStorageObj = this.props.getLocalStorageVar(localStorageVar);
		if(localStorageObj) {
			localStorage.removeItem(this.state.localStorageVar);
		} else {
			browserHistory.push("/login");
		}
	}

    render() {
        return (
			<div>
				<p>
					<strong>Your CustomerNet access is still pending approval. Please check back later.</strong><br/>
					If you have questions or concerns, please contact the account administrator at your company.
				</p>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

OppsNoAccount = connect(mapStateToProps)(OppsNoAccount);
export default OppsNoAccount;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/OppsNoAccount/index.js